import CountryPageRenderer from '../components/CountryPageRenderer';
import colombiaData from '../data/country-pages/colombia';

export default function ColombiaCountryPage() {
  return <CountryPageRenderer data={colombiaData} />;
}
